import { DateObject } from '@capsicum/common';

import { useSurveysQuery } from '../data-access';

export const useFurthestClaimableSurvey = (partnerId: string) => {
	const { data: surveyOpenData, isLoading } = useSurveysQuery({
		'details[]': ['surveyTranslations'],
		direction: 'desc',
		limit: 1,
		orderBy: 'closeAt',
		'partnerIds[]': partnerId ? [partnerId] : [],
		'statuses[]': ['opened', 'closed'],
		userVoted: true,
		version: '3'
	});

	const hasVotedSurveys = (surveyOpenData?.length ?? 0) > 0;
	const votingDate = new DateObject(surveyOpenData?.[0]?.processedAt);
	const claimingDate = new DateObject(surveyOpenData?.[0]?.closeAt);
	const surveyId = surveyOpenData?.[0]?.id;

	return {
		claimingDate,
		hasVotedSurveys,
		surveyId,
		surveysLoading: isLoading,
		votingDate
	} as const;
};
